export default "__VITE_ASSET__DfiMgGft__"